import Manager from "../../src/manager";
import React from "react";

function Mapper(data, status, response, error, component) {
	let output = [];
	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		id: {
			alias: "id",
			type: "text",
			editable,
		},
	};
}

function clickMeActivate(_this) {
	let manager = _this.props.manager;
	let data = _this.props.data;
	window["modal"].setState({
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		body: (
			<Manager
				module="modalForActivation"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

const ModalForCredit = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					data: [{}],
					replace: {},
					mapper: Mapper,
				},
			},
			template: "plain",
			templateConfiguration: {
				cardTopTemplate: function () {
					let _this = this;
					return (
						<div
							className="lightbox"
							id="terms"
							style={{ display: "block" }}>
							<div className="content">
								<h2 className="termsCosmote">
									Όροι Χρήσης για αγορά Πακέτων Internet με
									Πιστωτική/Χρεωστική/Προπληρωμένη κάρτα
								</h2>
								<div
									className="text scroll-content jspScrollable"
									tabIndex="0">
									<div style={{ overflowY: "scroll", height: "400px" }}>
										<div
											className="jspPane"
											style={{
												padding: "0px 30px 0px 0px",
												top: "0px; left: 0px; width: 688px",
											}}>
											<div className="q">1</div>
											<div className="ans">
												Η ανώνυμη εταιρεία με την επωνυμία «ΟΡΓΑΝΙΣΜΟΣ
												ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ ΕΛΛΑΔΟΣ Α.Ε» και τον δ.τ. «OTE Α.Ε» ή
												«ΟΤΕ» ή «COSMOTE» που εδρεύει στο Μαρούσι Αττικής, Λεωφ.
												Κηφισίας 99 (Τ.Κ. 15124), ΓΕΜΗ 002410501000, Α.Φ.Μ.
												094019245, Δ.Ο.Υ ΦΑΕ Αθηνών και τηλέφωνο 13888, παρέχει
												στους επισκέπτες του{" "}
												<a
													className="ans"
													href="https://www.cosmote.gr">
													https://www.cosmote.gr
												</a>{" "}
												και του COSMOTE App , φυσικά πρόσωπα (εφεξής «χρήστες»)
												που κάνουν εξουσιοδοτημένη χρήση εταιρικής σύνδεσης
												συνδρομητή της υπηρεσίας COSMOTE My Internet και
												εγγεγραμμένου στην υπηρεσία όπως προβλέπουν οι όροι της
												υπηρεσίας My Internet, την δυνατότητα αγοράς πακέτων
												internet (εφεξής «Υπηρεσία») με χρέωση στην προσωπική
												τους πιστωτική ή χρεωστική ή προπληρωμένη κάρτα.
											</div>
											<div className="q">2</div>
											<div className="ans">
												Η πληρωμή είναι δυνατή με την χρήση των
												πιστωτικών/χρεωστικών/προπληρωμένων καρτών τύπου VISA
												&amp; MASTERCARD. Η ανωτέρω Υπηρεσία παρέχεται σε
												συνεργασία με την Εθνική Τράπεζα, η οποία παρέχει ειδικά
												συστήματα για την ασφαλή διαβίβαση των στοιχείων της
												πιστωτικής/χρεωστικής/προπληρωμένης κάρτας. Εφόσον η
												συναλλαγή είναι επιτυχής ενεργοποιείται το επιλεγμένο
												πακέτο Internet με χρέωση στην
												πιστωτική/χρεωστική/προπληρωμένη κάρτα που έχει
												καταχωρηθεί στο περιβάλλον της τράπεζας. Η οθόνη στην
												οποία εισάγονται τα στοιχεία αυτά ανήκει στο περιβάλλον
												των συστημάτων της Εθνικής Τράπεζας και τα δεδομένα
												συλλέγονται απευθείας από αυτήν χωρίς την παρέμβαση του
												OTE. Οι συναλλαγές ολοκληρώνονται στο διαδικτυακό
												περιβάλλον της Εθνικής Τράπεζας ( https://www.nbg.gr )
												και ο ΟTE δε διατηρεί πρόσβαση σε στοιχεία όπως ο
												αριθμός κάρτας, η ημερομηνία λήξης και το cvv2. Συνεπώς
												ο ΟΤΕ ουδεμία ευθύνη φέρει για θέματα που τυχόν
												προκύψουν με οποιοδήποτε από τα παραπάνω στοιχεία. Για
												οποιαδήποτε αμφισβήτηση ή και ερώτηση σχετικά με
												χρεώσεις στην πιστωτική/χρεωστική/προπληρωμένη τους
												κάρτα οι χρήστες θα πρέπει να απευθύνονται απευθείας
												στην τράπεζα που έχει εκδώσει την κάρτα τους. Οι χρήστες
												θα παραλάβουν στο email που έχουν εισάγει κατά την
												διαδικασία αγοράς του πακέτου αποδεικτικό email αγοράς
												των πακέτων και ονομαστική απόδειξη. Ο ΟΤΕ χρεώνει τον
												χρήστη που παρήγγειλε την Υπηρεσία εφάπαξ, σύμφωνα με
												τον εκάστοτε ισχύοντα τιμοκατάλογο που βρίσκεται
												αναρτημένος στο{" "}
												<a
													className="ans"
													href="https://www.cosmote.gr/cs/cosmote/gr/pricelist.html?mtbid=7ce557a6-447e-5de4-e053-181f12ac3db5">
													https://www.cosmote.gr/cs/cosmote/gr/pricelist.html?mtbid=7ce557a6-447e-5de4-e053-181f12ac3db5
												</a>
												Σε περίπτωση αποτυχίας ενεργοποίησης του επιλεγμένου
												πακέτου Internet o Χρήστης ενημερώνεται με SMS. H
												επιστροφή των χρημάτων θα γίνει με εντολή του OTE προς
												την συνεργαζόμενη τράπεζα για απόδοση/επιστροφή των
												καταβληθέντων στην κάρτα με την οποία είχε ολοκληρωθεί η
												συναλλαγή.
											</div>
											<div className="q">3</div>
											<div className="ans">
												Με την επιλογή της άμεσης ενεργοποίησης παροχής των
												πακέτων Internet, χάνεται το δικαίωμα της υπαναχώρησης
												του νόμου 2251/1994 περί προστασίας του καταναλωτή.
											</div>
											<div className="q">4</div>
											<div className="ans">
												Για την Προστασία των Προσωπικών δεδομένων και της
												διατήρησης περιεχομένου του χρήστη ισχύει η Ενημέρωση
												Προστασίας Δεδομένων εφαρμογής My COSMOTE αναρτημένη στο{" "}
												<a
													className="ans"
													href="https://www.cosmote.gr/pdf/TermsConditions/Data_Privacy_Notice_My_COSMOTE_Application.pdf">
													https://www.cosmote.gr/pdf/TermsConditions/Data_Privacy_Notice_My_COSMOTE_Application.pdf
												</a>
											</div>
											<div className="q">5</div>
											<div className="ans">
												Η χρήση της Υπηρεσίας διέπεται από τους παρόντες όρους
												χρήσης καθώς και συμπληρωματικά και όπου τυγχάνουν
												εφαρμογής από τους όρους χρήσης του ηλεκτρονικού
												καταστήματος του ΟTE, e-shop COSMOTE My Internet και των
												όρων αγοράς με πιστωτική/χρεωστική κάρτα του Εταιρικού
												Χρήστη που βρίσκονται αναρτημένοι στο{" "}
												<a
													className="ans"
													href="https://www.cosmote.gr/cs/cosmote/gr/oroi_xrhshs_kinitis.html">
													https://www.cosmote.gr/cs/cosmote/gr/oroi_xrhshs_kinitis.html
												</a>{" "}
												τους οποίους οι χρήστες καλούνται να διαβάσουν και να
												αποδεχθούν.
											</div>
										</div>
									</div>
								</div>
								<a
									className="cancel addCursorPointer"
									onClick={() => {
										window["modal"].setState({ show: false });
										//remove class locked when modal closes
										document.getElementById("body").classList.remove("locked");
										// if (window.location.pathname === "/")
										//   clickMeActivate(_this);
									}}></a>
							</div>
						</div>
					);
				},
				includeProperties: ["none"],
				excludeProperties: [],
				events: {
					onClick: function (e) {},
				},
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default ModalForCredit;
